import React from 'react'
import css from './style.module.scss'
import HomePage from '../../pages'

const App = () => {
  return (
    <div className={css.app}>
      <HomePage />
    </div>
  )
}

export default App